var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.htmlTag && _vm.htmlTag !== '' ? _vm.htmlTag : 'div',{tag:"component",class:[
        _vm.className && _vm.className
            ? _vm.className
            : 'absolute h-screen left-0 top-0 w-full z-1',
        _vm.getColor,
        'lg:h-full' ]})}
var staticRenderFns = []

export { render, staticRenderFns }